<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="33.583"
    height="28.197"
    viewBox="0 0 33.583 28.197"
  >
    <path
      id="Path_1705"
      data-name="Path 1705"
      d="M12.267,28.871h.317V46.93A1.267,1.267,0,0,0,13.851,48.2h27.88A1.267,1.267,0,0,0,43,46.93V28.871h.317A1.267,1.267,0,0,0,44.583,27.6V21.267A1.267,1.267,0,0,0,43.316,20H12.267A1.267,1.267,0,0,0,11,21.267V27.6A1.267,1.267,0,0,0,12.267,28.871Zm31.049-7.6H12.267V27.6H43.316Zm-29.465,7.6h27.88V46.93H13.851Z"
      transform="translate(-11 -20)"
      :fill="color"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  name: "Shipment_Pending_Icon",
  props: {
    color: {
      default: "#1C274C",
    },
  },
};
</script>
